module.exports = __webpack_public_path__ + "img/6-11_Pulldown.9f4530af.png";